export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/how-we-work", label: "How We Work" },
  { to: "/cost-calculator", label: "Cost Calculator" },
  { to: "/about", label: "About" },
  { to: "/areas-we-cover", label: "Areas We Cover" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export const CATEGORIES = [
  { value: "extensions", label: "Extensions" },
  { value: "renovations", label: "Renovations" },
  { value: "conversions", label: "Conversions" },
  { value: "new-builds", label: "New Builds" },
  { value: "kitchens-bathrooms", label: "Kitchens & Bathrooms" },
  { value: "structural-work", label: "Structural Work" },
];

export const REGIONS = [
  { value: "bristol", label: "Bristol" },
  { value: "bath", label: "Bath" },
  { value: "weston-super-mare", label: "Weston-super-Mare" },
  { value: "somerset", label: "Somerset" },
  { value: "bridgwater", label: "Bridgwater" },
  { value: "taunton", label: "Taunton" },
  { value: "newport", label: "Newport" },
  { value: "south-wales", label: "South Wales" },
  { value: "devon", label: "Devon" },
];

export const HERO_IMG = "/api/uploads/brand/lux-uk-1.webp";
export const TEAM_IMG = "/api/uploads/brand/noor-van.webp";

export const categoryLabel = (v) => CATEGORIES.find((c) => c.value === v)?.label || v;
export const regionLabel = (v) => REGIONS.find((r) => r.value === v)?.label || v;

export const formatArticleDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};


export const PROJECT_TYPE_OPTIONS = [
  "House extension",
  "Full home renovation",
  "Loft conversion",
  "Garage conversion",
  "New build",
  "Structural alterations",
  "Kitchen renovation",
  "Bathroom renovation",
  "Other / not sure yet",
];

export const INVESTMENT_OPTIONS = [
  "Under £25,000",
  "£25,000–£40,000",
  "£40,000–£75,000",
  "£75,000–£125,000",
  "£125,000+",
  "Not sure yet",
];

export const STAGE_OPTIONS = [
  "Just exploring ideas",
  "Early planning — gathering information",
  "Designs being prepared",
  "Drawings complete — ready to price",
  "Planning permission submitted",
  "Planning permission approved",
  "Ready to start",
];

export const PLANNING_OPTIONS = [
  "Not required / permitted development",
  "Not sure — advice needed",
  "Application being prepared",
  "Application submitted",
  "Permission granted",
];

export const TIMEFRAME_OPTIONS = [
  "As soon as possible",
  "Within 3 months",
  "3–6 months",
  "6–12 months",
  "12+ months / flexible",
];

export const HEARD_OPTIONS = [
  "Google search",
  "Google Maps / Business Profile",
  "Instagram",
  "Recommendation",
  "Passed a NOOR site",
  "Other",
];
